(() => {
  'use strict';

  if (window.ewAutumnCountdownSyncV2) {
    window.ewAutumnCountdownSyncV2.update();
    return;
  }

  const productSelectors = {
    days: '[data-countdown-days]',
    hours: '[data-countdown-hours]',
    minutes: '[data-countdown-minutes]',
    seconds: '[data-countdown-seconds]'
  };
  function remaining(end, now) {
    const seconds = Math.max(0, Math.ceil((end - now) / 1000));
    return {
      days: Math.floor(seconds / 86400),
      hours: Math.floor(seconds / 3600) % 24,
      minutes: Math.floor(seconds / 60) % 60,
      seconds: seconds % 60
    };
  }

  function createProductCountdown() {
    if (document.querySelector('[data-sale-countdown]')) return;
    const priceSummary = document.querySelector('.ever-price-summary.is-on-sale');
    if (!priceSummary) return;

    const template = document.querySelector('template[data-sale-countdown-fallback]');
    let countdown;
    if (template && template.content && template.content.firstElementChild) {
      countdown = template.content.firstElementChild.cloneNode(true);
    } else {
      countdown = document.createElement('div');
      countdown.className = 'ever-sale-countdown';
      countdown.setAttribute('data-sale-countdown', '');
      countdown.setAttribute('aria-label', '30% off sale countdown');
      countdown.innerHTML =
        '<div class="ever-sale-countdown__heading">' +
          '<span class="ever-sale-countdown__badge">30% OFF</span>' +
          '<span class="ever-sale-countdown__title"><i aria-hidden="true"></i>Offer ends in</span>' +
        '</div>' +
        '<div class="ever-sale-countdown__timer" role="timer" aria-live="off">' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-days>00</strong><small>Days</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-hours>00</strong><small>Hrs</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-minutes>00</strong><small>Min</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-seconds>00</strong><small>Sec</small></span>' +
        '</div>';
    }

    priceSummary.classList.add('has-sale-countdown');
    priceSummary.insertAdjacentElement('afterend', countdown);
  }

  function ownProductCountdown(countdown) {
    if (countdown.__ewAutumnV2Owned) return countdown;

    // Clone once to detach digit nodes retained by the store-wide legacy timer.
    if (countdown.getAttribute('data-autumn-v2-owned') !== 'true') {
      const replacement = countdown.cloneNode(true);
      replacement.setAttribute('data-countdown-initialised', 'true');
      replacement.setAttribute('data-topbar-countdown-synced', 'true');
      replacement.setAttribute('data-autumn-v2-owned', 'true');
      countdown.parentNode.replaceChild(replacement, countdown);
      countdown = replacement;
    }

    countdown.__ewAutumnV2Owned = true;
    countdown.setAttribute('data-countdown-initialised', 'true');
    return countdown;
  }

  function updateProductCountdown(value, label, active) {
    if (active) createProductCountdown();

    document.querySelectorAll('[data-sale-countdown]').forEach(countdown => {
      countdown = ownProductCountdown(countdown);
      if (!active) {
        countdown.hidden = true;
        countdown.removeAttribute('data-countdown-ready');
        return;
      }

      Object.keys(productSelectors).forEach(unit => {
        const node = countdown.querySelector(productSelectors[unit]);
        if (node) node.textContent = String(value[unit]).padStart(2, '0');
      });
      const timer = countdown.querySelector('[role="timer"]');
      if (timer) timer.setAttribute('aria-label', label);
      countdown.hidden = false;
      countdown.setAttribute('data-countdown-ready', 'true');
    });
  }

  function update() {
    const bar = document.querySelector('[data-autumn-bar]');
    if (!bar) return;

    const raw = bar.getAttribute('data-end-at') || '';
    const anchorEnd = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
    const now = Date.now();
    const end = anchorEnd;
    const active = Number.isFinite(end) && end > now;

    if (!active) {
      bar.hidden = true;
      updateProductCountdown(null, '', false);
      return;
    }

    const value = remaining(end, now);
    Object.keys(value).forEach(unit => {
      const node = bar.querySelector(`[data-unit="${unit}"]`);
      if (node) node.textContent = String(value[unit]).padStart(2, '0');
    });
    const label = `${value.days} days, ${value.hours} hours, ${value.minutes} minutes, ${value.seconds} seconds remaining`;
    const clock = bar.querySelector('[role="timer"]');
    if (clock) clock.setAttribute('aria-label', label);
    bar.hidden = false;
    updateProductCountdown(value, label, true);
  }

  window.ewAutumnCountdownSyncV2 = {update};
  update();
  window.setInterval(update, 250);
  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
